import React from 'react'
import ModalEliminar from './CREModalEliminar'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../../reducers'
import { comprobanteRetencionDocumentosClearAll, comprobanteRetencionModalsClose, } from '../../../../../actions/comprobante-retencion/comprobanteRetencionProductos.actions'
import {generalOpenModalInfo} from '../../../../../actions/general.actions'
import CREModalDocumentos from './CREModalDocumentos'
import CREAgregarDocumento from './CREAgregarDocumento'

const CREModalsGeneracion = () => {
  const {activeQuitarTodo} = useSelector((state: State) => state.comprobanteRetencion.modals)
  const open = useSelector((state: State) => state. comprobanteRetencion.modalDocumentos.open)
  const openF = useSelector((state: State) => state. comprobanteRetencion.fisico.open)
  const dispatch = useDispatch()

  const closeModalEliminar = () => dispatch(comprobanteRetencionModalsClose())

  const actionEliminar = () => {
    if (activeQuitarTodo) {
      dispatch(comprobanteRetencionDocumentosClearAll())
      dispatch(generalOpenModalInfo('Todos los documentos asociados se han removido exitosamente.'))
    }
    closeModalEliminar()
  }
  return (
    <>
      {(activeQuitarTodo) && (<ModalEliminar eliminar={false} closeModalEliminar={closeModalEliminar} actionEliminar={actionEliminar} />)}
      {open && <CREModalDocumentos />}
      {openF && <CREAgregarDocumento />}
    </>
  )
}

export default CREModalsGeneracion
